import React from 'react';
import VCardResume from './VCardResume';
import VCardActions from './VCardActions';
import PropTypes from 'prop-types';
import { VCARD_DETAILS_MAIN_CLASSNAME, VCARD_SEASON_BUY_CLASSNAME} from '../Constants';
import { cls } from '../../../packages/components';
import Translator from "../../../../src/requests/apa/Translator";
import DeviceStorage  from '../../../components/DeviceStorage/DeviceStorage';

class VCardDetails extends React.Component {
    constructor(props) {
        super(props);
        this._region = DeviceStorage.getItem('region');
        // Cache para evitar recrear objetos en cada render
        this._cachedBgStyle = null;
        this._prevImage = undefined;
        this._cachedHasBuyTransactional = false;
        this._prevButtons = undefined;
    }

    shouldComponentUpdate(nextProps) {
        return (
            nextProps.data !== this.props.data ||
            nextProps.buttons !== this.props.buttons ||
            nextProps.isLoading !== this.props.isLoading ||
            nextProps.addonDescription !== this.props.addonDescription ||
            nextProps.dataEpisodes !== this.props.dataEpisodes ||
            nextProps.notification !== this.props.notification
        );
    }

    componentWillUnmount() {
        this._cachedBgStyle = null;
    }

    render() {
        const { data, buttons, addonDescription, isLoading, dataEpisodes, notification } = this.props;
        const {
            title = '',
            episode = null,
            subtitle = '',
            genders = [],
            year = '',
            parentalRating = '',
            duration = '',
            synopsis = '',
            image = '',
            isSerie = false,
            progress = 0
        } = data || {};

        // Cache background style
        if (image !== this._prevImage) {
            this._prevImage = image;
            this._cachedBgStyle = { backgroundImage: "url('" + image + "')" };
        }

        // Cache hasBuyTransactional
        if (buttons !== this._prevButtons) {
            this._prevButtons = buttons;
            let found = false;
            for (let i = 0; i < buttons.length; i++) {
                const text = buttons[i].text;
                if (typeof text === 'string' && (text.indexOf('Temporada') !== -1 || text.indexOf('Episodio') !== -1)) {
                    found = true;
                    break;
                }
            }
            this._cachedHasBuyTransactional = found;
        }
        const hasBuyTransactional = this._cachedHasBuyTransactional;

        return (
            <div className={cls(VCARD_DETAILS_MAIN_CLASSNAME)} style={this._cachedBgStyle}>
                <div className="gradient">
                    <div className="gradientTop">
                        <VCardResume
                            isLoading={isLoading}
                            title={title}
                            subtitle={subtitle}
                            genders={genders}
                            year={year}
                            parentalRating={parentalRating}
                            duration={duration}
                            synopsis={synopsis}
                            isSerie={isSerie}
                            progress={progress}
                            addonDescription={addonDescription}
                            episode={episode}
                            dataEpisodes={dataEpisodes}
                            notification={notification}
                        />
                        <VCardActions buttons={buttons} isLoading={isLoading}/>
                    </div>
                    {!isLoading && isSerie && hasBuyTransactional && (
                        <div className={cls(VCARD_SEASON_BUY_CLASSNAME)}>
                            {Translator.get(`cv_episodebuy_download_buy_${this._region}_wp0_disclaimer`, '')}
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

VCardDetails.propTypes = {
    data: PropTypes.shape({
        title: PropTypes.string.isRequired,
        subtitle: PropTypes.string,
        episode: PropTypes.object,
        genders: PropTypes.arrayOf(PropTypes.string).isRequired,
        year: PropTypes.string.isRequired,
        parentalRating: PropTypes.string.isRequired,
        duration: PropTypes.string.isRequired,
        synopsis: PropTypes.string.isRequired,
        image: PropTypes.string.isRequired,
        isSerie: PropTypes.bool.isRequired,
        progress: PropTypes.number,
    }),
    buttons: PropTypes.array,
    addonDescription: PropTypes.node,
    isLoading: PropTypes.bool,
    notification: PropTypes.element,
}

VCardDetails.defaultProps = {
    data: {},
    buttons: [],
    addonDescription: null,
    isLoading: false,
    notification: null
}

export default VCardDetails;



// WEBPACK FOOTER //
// ./src/components/Ficha/components/VCardDetails.jsx